import React, { useContext } from "react";
import { makeStyles } from "tss-react/mui";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import ClbsAppBar from "../wrapper/appBar";
import ClbsLabel from "../config/assessmentLabel";
import { LanguageContext } from "../context/languageContext";
import { assessmentLabels } from "../config/commonLabels";

const useStyles = makeStyles()({
  card: {
    margin: "20px",
    width: "auto",
    padding: "20px",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function Home() {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);

  return (
    <ClbsAppBar>
      <Grid container justifyContent="center">
        <Card className={classes.card}>
          <CardContent>
            <ClbsLabel />
          </CardContent>
          <Grid container justifyContent="flex-end">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate("/clbsQuestions")}
              style={{ marginInline: "0.5em" }}
            >
              {assessmentLabels.start[language]}
            </Button>
            <Button variant="outlined" style={{ marginInline: "0.5em" }}>
              {assessmentLabels.help[language]}
            </Button>
          </Grid>
        </Card>
      </Grid>
    </ClbsAppBar>
  );
}
